import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mocuts/result_back.webp";

function Resultmocuts() {
  return (
    <section
      className="result_mocuts text_mocuts"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-md-7 offset-xl-7 offset-lg-7"
          >
            <h2>
              <span>The</span> Result
            </h2>
            <p>
              MoCuts Pro is now available globally, with native iOS and Android
              versions available on both the Play Store and the App Store.
              Thousands of customers and service providers are joining MoCuts
              Pro every day, and the platform has gained a global reputation as
              one of the best online barber service platforms.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultmocuts;
